import { type Theme, css } from "@emotion/react";

// This is required to change the styles of the month button
// This can't be configured within a theme
export const datePicker = (theme: Theme) => {
  return {
    "& .PrivatePickersMonth-root": {
      border: "none",
      backgroundColor: theme.surface.level1,
    },
  };
};

// This is required to change the color/size of the label whenever you click into an input field
// This can't be configured within a theme
export const textField = (theme: Theme) => {
  return {
    "& .MuiFormLabel-root.Mui-focused": {
      color: theme.system.textBase,
      fontSize: theme.aviaryTypography.body.fontSize,
      transform: "translate(1rem, 7px) scale(0.85)",

      "&.Mui-error": {
        color: theme.danger.textBase,
      },
    },
  };
};

export const DatePickerWrapper = css`
  display: flex;
  flex-direction: column;
`;
